require("./SelectCategory.marko.css");
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
    onCreate: function () {
        this.state = { list: [] };
    },
    onMount: function () {
        this.fetchCategories();
    },
    fetchCategories: async function () {
        try {
            const {error, message, results} = await Request('/category/list');
            if (error)
                throw new Error(message);
            const self = this;
            this.state.list = [];
            (function collector(arrayList) {
                arrayList.map(({name, categoryId, subs}) => {
                    self.state.list.push({
                        name,
                        categoryId
                    });
                    if (!!subs && !isEmpty(subs))
                        collector(Object.values(subs));
                });
            }(results));
            this.setStateDirty('list');
        } catch (error) {
            console.log('Fetch Categories Failed: ', error);
        }
    },
    onSelect: function (id, name) {
        this.emit('select', id, name);
    },
    onSelectAll: function () {
        this.emit('select-all', this.state.list.map(({categoryId}) => {
            return categoryId;
        }));
    },
    onAddCategory: function () {
        this.emit('add');
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/SelectCategory.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Bx_template = require("../../components/Bx/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Bx_tag = marko_loadTag(Bx_template),
    Locale_template = require("../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_attrs0 = {
        "class": "font-medium-2 cursor-pointer nav-item px-2 py-50"
      },
    marko_attrs1 = {
        "class": "font-medium-2 cursor-pointer nav-item px-2 py-50"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("0e3429"),
    marko_node0 = marko_createElement("i", {
        "class": "left bx bx-plus"
      }, "7", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("i", {
        "class": "left bx bx-plus"
      }, "9", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "text-center p-1"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", {
      "class": marko_classValue(marko_classValue([
        "btn-group dropdown",
        input.class
      ]))
    }, "0", component, null, 1);

  if (!input.decoupled) {
    out.be("button", {
        type: "button",
        "class": marko_classValue((("btn " + (input.btnType || "theme-bg-lighten")) + " py-50 align-middle rounded ") + (input.disabled ? " disabled" : "")),
        "data-toggle": !input.disabled ? "dropdown" : ""
      }, "1", component);

    Bx_tag({
        type: "plus",
        class: "font-medium-3 float-left"
      }, out, __component, "2");

    Locale_tag({
        text: input.label || "Add",
        class: "font-medium-3"
      }, out, __component, "3");

    out.ee();
  }

  out.be("ul", {
      "class": marko_classValue(((("dropdown-menu border theme-bg py-0 " + (input.position ? " dropdown-menu-" + input.position : "")) + " ") + (input.decoupled ? "show" : "")) + " overflow-auto"),
      style: "max-height:25rem"
    }, "4", component, null, 1);

  if (state.list.length) {
    if (input.selectAll) {
      out.e("li", marko_attrs0, "5", component, 1, 0, {
          onclick: __component.d("click", "onSelectAll", false)
        })
        .t("All");
    }

    marko_forOf(state.list, function({ categoryId, name }, index) {
      out.e("li", marko_attrs1, "@" + ("category-" + index), component, 1, 0, {
          onclick: __component.d("click", "onSelect", false, [
              categoryId,
              name
            ])
        })
        .t(name, component);
    });

    if (input.add) {
      out.e("li", {
          "class": marko_classValue("font-medium-2 cursor-pointer nav-item px-2 py-50 " + (state.list.length ? "border-top mt-50" : ""))
        }, "6", component, 2, 1, {
          onclick: __component.d("click", "onAddCategory", false)
        })
        .n(marko_node0, component)
        .t(" Add New");
    }
  } else if (input.add) {
    out.be("li", {
        "class": marko_classValue("font-medium-2 cursor-pointer nav-item px-2 py-75 " + (state.list.length ? "border-top mt-50" : ""))
      }, "8", component, null, 1, {
        onclick: __component.d("click", "onAddCategory", false)
      });

    out.n(marko_node1, component);

    out.t(" ");

    Locale_tag({
        text: "Add New"
      }, out, __component, "10");

    out.ee();
  } else {
    out.be("div", marko_attrs2, "11", component);

    Locale_tag({
        renderBody: function(out) {
          out.t("No Category Found");
        }
      }, out, __component, "12");

    out.ee();
  }

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
